import { Button, Card, Flex, Image, Skeleton } from "antd";
import { useEffect, useState } from "react";
import AgentService from "../../Services/agent/agent.service";
import Typewriter from "../../Utils/typewriter";
import "./index.scss";

const DynamicNotification = () => {
  const [isLoading] = useState(false);
  const [currentMessage, setCurrentMessage] = useState("");
  const [currentAction, setCurrentAction] = useState("");
  const [showActionButton, setShowActionButton] = useState(false);

  useEffect(() => {
    AgentService.getInstance().subscribe(
      AgentService.EVENTS.STATE_CHANGED,
      onStateChange
    );
    const currentState = AgentService.getInstance().currentMessage;
    setCurrentMessage(currentState);
  }, []);

  const onStateChange = (message: string) => {
    console.debug("DynamicNotification: state changed", message);
    setShowActionButton(false);
    setCurrentMessage(message);
    setCurrentAction(AgentService.getInstance().currentAction);
  };

  const onActionButtonClick = async () => {
    AgentService.getInstance().onActionButtonClicked(currentAction);
  };

  return (
    <>
      {isLoading ? (
        <Skeleton avatar paragraph={{ rows: 2 }} />
      ) : (
        <Card className="dynamic_notification_card">
          <Flex align="center" gap={16} justify="center">
            <Image
              src="/assets/agent.svg"
              alt="ai_icon"
              className="agent_icon"
              preview={false}
            />
            <div className="agent_message_container">
              <span className="agent_message_text">
                <Typewriter
                  text={currentMessage}
                  delay={20}
                  onAnimationComplete={() => setShowActionButton(true)}
                />
              </span>

              {currentAction && showActionButton && (
                <Button
                  type="default"
                  className="dynamic_card_button"
                  onClick={onActionButtonClick}
                  loading={isLoading}
                >
                  {currentAction}
                </Button>
              )}
            </div>
          </Flex>
          {currentAction && showActionButton && (
            <Button
              className="mobile_only_button"
              onClick={onActionButtonClick}
              loading={isLoading}
              type="primary"
            >
              {currentAction}
            </Button>
          )}
        </Card>
      )}
    </>
  );
};

export default DynamicNotification;
